/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license See LICENSE file distributed with this source code.
 */

import React from "react";

import { FormFieldSelect } from "../../../shared/FormModel/elements/FormFieldSelect";
import { FormFieldWrapperComponent } from "./FormFieldWrapperComponent";

/**
 * Component props
 */
export interface IFormFieldSelectComponentProps {
	element: FormFieldSelect
}

/**
 * Form Field Text component
 *
 * @param props Component props
 */
export function FormFieldSelectComponent(props: IFormFieldSelectComponentProps) {

	const handleChange = (ev) => {
		props.element.set(ev.target.value);
	};

	return <FormFieldWrapperComponent {...props} render={(state, stl) => {

		let currVal = null;

		const mods = [
			"align-" + (state.config.align || "left")
		];

		for (let i = 0; i < state.config.options.length; i++) {
			if (state.config.options[i].value === state.value) {
				currVal = state.config.options[i];
				break;
			}
		}

		return <>
			<select
				name={state.valueId}
				value={state.value}
				onChange={handleChange}
				className={stl.el("select").mod(mods).str}
			>
				{state.config.options.map((option) =>
					<option key={option.value} value={option.value}>{option.label}</option>
				)}
			</select>
			<span className={stl.el("input-print").mod(mods).str}>{currVal ? currVal.label : "-"}</span>
		</>

	}} />

}